export default "__VITE_ASSET__VP7mPEVg__"